import React from 'react';
import { motion } from 'framer-motion';
import { usePrefersReducedMotion } from './motion';
type MiniServiceVisualProps = {
  variant: 'system' | 'yelp' | 'websites';
};

/* Small living visuals for the homepage's three service cards -- not a
   glyph or an icon-in-a-box, a compact version of the same motion
   language used across components/visuals (emerald fill, dashed
   connectors, whileInView reveals). Each is under 96px tall so it reads
   as a detail, not a competing hero. */
export function MiniServiceVisual({
  variant
}: MiniServiceVisualProps) {
  const reducedMotion = usePrefersReducedMotion();
  if (variant === 'system') {
    const nodes = [0, 1, 2];
    return <div className="flex h-16 items-center justify-center gap-3" aria-hidden="true" data-id="element-759" data-mp="3hmim45p26ur4">
        {nodes.map(n => <React.Fragment key={n} data-id="element-760" data-mp="1ku8prb2a5b7s">
            <motion.span className="h-2.5 w-2.5 rounded-full bg-emerald-500" animate={reducedMotion ? {} : {
          opacity: [0.3, 1, 0.3]
        }} transition={{
          duration: 1.8,
          repeat: Infinity,
          delay: n * 0.35,
          ease: 'easeInOut'
        }} data-id="element-761" data-mp="1ktgwi6w5npko" />
            {n < nodes.length - 1 && <span className="h-px w-6 bg-[#232323]" data-id="element-762" data-mp="2hra8fohw14x" />}
          </React.Fragment>)}
      </div>;
  }
  if (variant === 'yelp') {
    const bars = [30, 55, 40, 75];
    return <div className="flex h-16 items-end justify-center gap-2" aria-hidden="true" data-id="element-763" data-mp="3plnxw78luucd">
        {bars.map((h, i) => <motion.span key={i} className="w-3 rounded-t bg-emerald-500/70" style={{
        height: `${h}%`,
        transformOrigin: 'bottom'
      }} initial={reducedMotion ? false : {
        scaleY: 0
      }} whileInView={{
        scaleY: 1
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: i * 0.08,
        ease: 'easeOut'
      }} data-id="element-764" data-mp="h645fafrdfyd" data-mpi={i} />)}
      </div>;
  }
  return <div className="flex h-16 items-center justify-center" aria-hidden="true" data-id="element-765" data-mp="14v6ngjeb1ate">
      <div className="w-28 overflow-hidden rounded-md border border-[#232323] bg-[#0d0d0d]" data-id="element-766" data-mp="1eqnbljno1sjz">
        <div className="flex items-center gap-1 border-b border-[#1c1c1c] bg-[#111] px-2 py-1" data-id="element-767" data-mp="19rsseglse1zc">
          <span className="h-1.5 w-1.5 rounded-full bg-neutral-700" data-id="element-768" data-mp="14spmktxzfrqb" />
          <span className="h-1.5 w-1.5 rounded-full bg-neutral-700" data-id="element-769" data-mp="14qwhhj30pfkf" />
          <span className="h-1.5 w-1.5 rounded-full bg-neutral-700" data-id="element-770" data-mp="10q2tyqthm2s2" />
        </div>
        <div className="space-y-1 p-2" data-id="element-771" data-mp="vsb0vth3wama">
          <motion.span className="block h-2 rounded-sm bg-emerald-500/60" initial={reducedMotion ? false : {
          width: '20%'
        }} whileInView={{
          width: '80%'
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} data-id="element-772" data-mp="vtcbxxy4gx40" />
          <span className="block h-2 w-1/2 rounded-sm bg-[#232323]" data-id="element-773" data-mp="h1agqr6zysab" />
          <span className="block h-2 w-2/3 rounded-sm bg-[#232323]" data-id="element-774" data-mp="d10d3l6ogdym" />
        </div>
      </div>
    </div>;
}